import type {CodeList} from 'services/codelists/types';
import {isNullish} from 'schemaDefinition';
import type {ManifestationImportProps} from 'services/metadata/types';

const excludedProductForms = (code: string): boolean => {
  return [
    'PZ', // Andre trykte artikler
    'PM', // Mappe
    'PK', // Plakat
    'PC', // Kalender
    'PA', // Diverse trykk
  ].includes(code);
};

export function getRestrictedProductFormDetailCodelist(
  {manifestation: {productForm}}: ManifestationImportProps,
  codelist: CodeList,
): CodeList {
  return isNullish(productForm)
    ? codelist
    : {
        ...codelist,
        codes: codelist.codes.map(item => {
          // Matching first letter
          const include =
            item.code[0] === productForm[0] ||
            // Or Ebok and Blokkbokstaver
            (productForm === 'ED' && item.code === 'B611');

          // Never show detail options for these productforms
          const excluded = excludedProductForms(productForm);

          return include && !excluded ? item : {...item, disabled: true};
        }),
      };
}
